import * as React from "react";
import { Typography } from "@material-ui/core";

export interface PreviewFontsProps {
  headingFont: string;
  bodyFont: string;
  textColor?: string;
}

const PreviewFonts: React.FunctionComponent<PreviewFontsProps> = ({
  headingFont,
  bodyFont,
  textColor = "#ffffff",
}) => {
  return (
    <div style={{ color: "#000000" }}>
      <Typography
        variant="h5"
        style={{
          fontFamily: headingFont ? `${headingFont}, sans-serif` : "inherit",
          marginBottom: 12,
          color: "black",
        }}
      >
        Select Order Type
      </Typography>
      <Typography
        variant="body1"
        style={{
          fontFamily: bodyFont ? `${bodyFont}, sans-serif` : "inherit",
          color: "black",
        }}
      >
        How would you like to place your order? Choose a font to preview it
        instantly across headings and body text.
      </Typography>
    </div>
  );
};

export default PreviewFonts;
